import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Grid, Stack, Box, Typography, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import useAuth from "src/hooks/useAuth";
import { YellowLogo } from "src/components/Logo";
import ProfileFormDialog from "../components/ProfileFormDialog";
import { PATH_DASHBOARD } from "src/routes/paths";

export default function ProfileSwitcher() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { profiles, switchProfile } = useAuth();

  return (
    <Container maxWidth="md">
      <Stack
        justifyContent="center"
        direction="row"
        sx={{ my: { xs: 1, sm: 1.5, md: 2 } }}
      >
        <YellowLogo />
      </Stack>
      <Typography
        variant="h4"
        textAlign="center"
        sx={{ my: { xs: 1, sm: 1.5, md: 2 } }}
      >
        Choose a profile
      </Typography>
      <Grid
        container
        spacing={{ xs: 1, sm: 2, md: 3 }}
        justifyContent="center"
        sx={{ my: { xs: 1, sm: 1.5, md: 2 } }}
      >
        {profiles.map((profile, idx) => (
          <Grid key={profile.id} item xs={4} sm={3} md={2}>
            <Stack spacing={0.5}>
              <Box
                component="img"
                // src={profile.icon}
                src={`/static/images/account/${idx + 1}.jpg`}
                sx={{
                  width: "100%",
                  height: 90,
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  switchProfile(profile.id);
                }}
              />
              <Typography textAlign="center" variant="subtitle2">
                {profile.name}
              </Typography>
            </Stack>
          </Grid>
        ))}
        <Grid key="add" item xs={4} sm={3} md={2}>
          <Stack spacing={0.5}>
            <Box
              sx={{
                width: "100%",
                height: 90,
                borderRadius: "4px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                bgcolor: "grey.900",
              }}
              onClick={() => {
                setOpen(true);
              }}
            >
              <AddIcon sx={{ fontSize: { xs: 30, sm: 35, md: 40 } }} />
            </Box>
            <Typography textAlign="center" variant="subtitle2">
              Add Profile
            </Typography>
          </Stack>
        </Grid>
      </Grid>
      <Stack
        justifyContent="center"
        direction="row"
        sx={{ my: { xs: 1, sm: 1.5, md: 2 } }}
      >
        <Button
          color="inherit"
          variant="contained"
          size="large"
          onClick={() => navigate(PATH_DASHBOARD.manageProfiles)}
        >
          Edit Profiles
        </Button>
      </Stack>
      {open && (
        <ProfileFormDialog
          open={open}
          currentProfile={null}
          handleClose={() => {
            setOpen(false);
          }}
        />
      )}
    </Container>
  );
}
